export default "__VITE_ASSET__RWbyJ_HK__"